export default {
  title: 'Atribute dietetice',
};
